<template>
  <FullScreenMap v-slot="{ fullScreen }">
    <Box :aspect="0.4" class="map-container mb-15" :class="{ '!h-screen !w-screen': fullScreen }">
      <ShowLocationMap
        :points="points"
        :show-info="true"
        :hide-inner-circle="true"
      >
        <template #info="{ point }">
          <h6>{{ point.name }}</h6>
          {{
            $t('pages.campaigns.focusPointList.map.infoWindowText', {
              threshold: formatTimeDurationFromSeconds(point.threshold ?? 0),
              cardinality: point.cardinality,
            })
          }}
          <br>
          {{
            $t('pages.campaigns.focusPointList.map.infoWindowText2', {
              totalStops: point.totalStops,
              totalTime: formatTimeDurationFromSeconds(point.totalTime ?? 0),
              totalPhotos: point.totalPhotos
            })
          }}
        </template>
      </ShowLocationMap>
    </Box>
  </FullScreenMap>
</template>

<script lang="ts" setup>
import Box from '@components/utils/Box.vue';
import {
  computed,
} from 'vue';
import type { FocusPoint } from '@/entities/Entities';
import {formatTimeDurationFromSeconds} from '@/utils/helpers';
import ShowLocationMap from '@utils/maps/ShowLocationMap.vue';
import FullScreenMap from '@utils/FullScreenMap.vue';

interface Props {
  points?: FocusPoint[];
}

const props = defineProps<Props>();
const points = computed(() => props.points?.map((point) => ({
  id: point.id,
  gisLocation: point.gisLocation,
  radius: point.radius,
  value: point.threshold,
  name: point.name,
  threshold: point.threshold,
  cardinality: point.cardinality,
  totalStops: point.statistics.totalStops,
  totalTime: point.statistics.totalTime,
  totalPhotos: point.statistics.totalPhotos
})));
</script>
